import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/sayfa',
    name: 'PageIndex',
    component: () => import(/* webpackChunkName: "page" */ '@/views/PageView'),
    children: [
      {
        path: '/sayfa/iletisim',
        name: 'ContactPage',
        component: () => import('@/views/pages/ContactPage')
      },
      {
        path: '/sayfa/banka-hesap-numarasi',
        name: 'BankAccounts',
        component: () => import('@/views/pages/BankAccounts')
      },
      {
        path: ':slug',
        name: 'Page',
        component: () => import('@/views/pages/Default'),
        meta: {
          beforeSlug: 'pages'
        }
      }
    ]
  },
  {
    path: '/blog',
    name: 'BlogIndex',
    component: () => import(/* webpackChunkName: "page" */ '@/views/PageView'),
    children: [
      {
        path: ':slug',
        name: 'BlogPage',
        component: () => import('@/views/pages/Default'),
        meta: {
          beforeSlug: 'blogs'
        }
      }
    ]
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return {y: 0}
  }
})

export default router
